export default [
    { key: 'name', label: 'Nombre' },
    { key: 'address', label: 'Dirección' },
    { key: 'client.name', label: 'Cliente' },
    { key: 'venue.name', label: 'Sede' },
    { key: 'actions', label: '' },
]